export const colorList: string[] = ['green', 'red', 'yellow', 'gray'];

export const shouldUpdateHubspot = (oldColor: string, newColor: string) => {
  if (!colorList.includes(newColor)) return false;
  if (newColor === 'gray') {
    return false;
  }
  if (oldColor === 'gray' && newColor === 'green') {
    return false;
  }
  return true;
};

export const shouldSendEmail = (newColor: string) => {
  if (!colorList.includes(newColor)) return false;
  if (newColor === 'yellow' || newColor === 'red') {
    return true;
  }
  return false;
};
